export default __webpack_public_path__ + "static/media/icon-instagram.921b1e5b.svg";